import { Link } from "react-router-dom";
import React from "react";
import Slider from "react-slick";


export default function PopularFlightsRoutes() {
var HotelSlider = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          HotelSlider: {
             slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          autoplay: true,
          autoplaySpeed: 2000,
            dots: true
          }
        },
        {
          breakpoint: 600,
          HotelSlider: {
              slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          autoplay: true,
          autoplaySpeed: 2000,
            dots: true
          }
        },
        {
          breakpoint: 480,
          HotelSlider: {
              slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          autoplay: true,
          autoplaySpeed: 2000,
            dots: true
          }
        }
      ]
    };
  return (
<>

  <section id="PopularFlightsRoutes" className="section-with-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
        
<h2><strong>Our Best Flight Deals</strong> Worldwide</h2>
          <p>Her are some Popular Flights for your Desitinations</p>
          
        </div>

        <div className="row" data-aos="fade-up" data-aos-delay="100">
              <Slider {...HotelSlider}>
          <div className="col-lg-4 col-md-6 col-xs-12">
            <div className="hotel">
              <div className="hotel-img">
                <img src={"../assets/img/flights/air-travel (16).avif"} alt="Hotel 1" className="img-fluid" />
              </div>
              <h3><a href="#">New York to New Delhi(DEL)</a></h3>
              <p className="upto_dis">Save Upto <i className="rates_us">$</i>100* On internation Flight </p>
              <div className="stars">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
              </div>
              <p>Special Fares to Various Sector</p>
              <div className="pricesandlists">
<p className="exclusive_save"><span className="frm_style"></span><i className="rates_us">$</i>100 OFF*</p>
<button type="button" className="btn btn-danger airline_pick" id="air10">Book Now</button>
</div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-xs-12">
            <div className="hotel">
              <div className="hotel-img">
                <img src={"../assets/img/flights/air-travel (17).avif"} alt="Hotel 2" className="img-fluid" />
              </div>
              <h3><a href="#">London to Mumbai(BOM)</a></h3>
            <p className="upto_dis">Save Upto<i className="rates_us">$</i>90* On internation Flight </p>
              <div className="stars">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill-half-full"></i>
              </div>
              <p>Special Fares to Various Sector</p>
               <div className="pricesandlists">
<p className="exclusive_save"><span className="frm_style"></span><i className="rates_us">$</i>90 OFF*</p>
<button type="button" className="btn btn-danger airline_pick" id="air10">Book Now</button>
</div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-xs-12">
            <div className="hotel">
              <div className="hotel-img">
                <img src={"../assets/img/flights/air-travel (18).avif"} alt="Hotel 3" className="img-fluid" />
              </div>
              <h3><a href="#">Peris to Varanasi(VNS)</a></h3>
              <p className="upto_dis">Save Upto<i className="rates_us">$</i>100* On internation Flight </p>
              <div className="stars">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
              </div>
              <p>Special Fares to Various Sector</p>
              <div className="pricesandlists">
<p className="exclusive_save"><span className="frm_style"></span><i className="rates_us">$</i>100 OFF*</p>
<button type="button" className="btn btn-danger airline_pick" id="air10">Book Now</button>
</div>
            </div>
          </div>
     <div className="col-lg-4 col-md-6 col-xs-12">
            <div className="hotel">
              <div className="hotel-img">
                <img src={"../assets/img/flights/air-travel (19).avif"} alt="Hotel 1" className="img-fluid" />
              </div>
              <h3><a href="#">New York to New Delhi(DEL)</a></h3>
              <p className="upto_dis">Save Upto <i className="rates_us">$</i>100* On internation Flight </p>
              <div className="stars">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
              </div>
              <p>Special Fares to Various Sector</p>
              <div className="pricesandlists">
<p className="exclusive_save"><span className="frm_style"></span><i className="rates_us">$</i>100 OFF*</p>
<button type="button" className="btn btn-danger airline_pick" id="air10">Book Now</button>
</div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-xs-12">
            <div className="hotel">
              <div className="hotel-img">
                <img src={"../assets/img/flights/air-travel (20).avif"} alt="Hotel 2" className="img-fluid" />
              </div>
              <h3><a href="#">London to Mumbai(BOM)</a></h3>
            <p className="upto_dis">Save Upto<i className="rates_us">$</i>90* On internation Flight </p>
              <div className="stars">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill-half-full"></i>
              </div>
              <p>Special Fares to Various Sector</p>
               <div className="pricesandlists">
<p className="exclusive_save"><span className="frm_style"></span><i className="rates_us">$</i>90 OFF*</p>
<button type="button" className="btn btn-danger airline_pick" id="air10">Book Now</button>
</div>
            </div>
          </div>
             </Slider>                     

        </div>
      </div>

    </section>
 
    </>
  );
}
